import { UBXColor } from '../color/color.enum';

export class UBXToast {
    type: UBXColor;
    position: UBXToastPosition;
    label: string;
    message: string;
    timer: number;
}
export enum UBXToastPosition {
    TopLeft = 0,
    TopRight = 1,
    BottomLeft = 2,
    BottomRight = 3,
}
